import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const FormErrorMessage = ({ message = '', className = '', id }) => {
  return (
    !!message && (
      <p id={id} className={classnames('text-start text-danger medium mb-0', className)}>
        {message}
      </p>
    )
  );
};

FormErrorMessage.propTypes = {
  id: PropTypes.string,
  message: PropTypes.string,
  className: PropTypes.string,
};
